(function () {
  if (window.__paginationInit) return;
  window.__paginationInit = true;

  function loadItems(nextUrl, onDone) {
    return fetch(nextUrl)
      .then((res) => res.text())
      .then((data) => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, "text/html");

        const newItems = htmlDoc.querySelectorAll(".load-wrapper .load-item");
        const container = document.querySelector(".load-wrapper");
        if (container && newItems.length) {
          newItems.forEach((item) => container.appendChild(item));
        }

        if (typeof onDone === "function") onDone(htmlDoc);
      });
  }

  // ---------- Loadmore button ----------
  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".btn-loadmore");
    if (!btn) return;

    const nextUrl = btn.getAttribute("data-next-url");
    const wrapPagi = document.querySelector(".loadmore-wrap");
    if (!nextUrl) return;

    btn.classList.add("load");

    loadItems(nextUrl, function (htmlDoc) {
      const newNext = htmlDoc.querySelector(".btn-loadmore");
      if (newNext && newNext.getAttribute("data-next-url")) {
        btn.setAttribute("data-next-url", newNext.getAttribute("data-next-url"));
        btn.classList.remove("load");
      } else {
        btn.remove();
        wrapPagi?.remove();
      }

      if (typeof events === "function") events();
    });
  });

  // ---------- Infinite scroll ----------
  function initInfinite() {
    const trigger = document.querySelector(".infinite-scroll-trigger");
    if (!trigger) return;

    const wrapPagi = document.querySelector(".infinite-wrap");
    let isLoading = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          if (isLoading) return;

          const nextUrl = trigger.getAttribute("data-next-url");
          if (!nextUrl) return;

          isLoading = true;

          loadItems(nextUrl, function (htmlDoc) {
            const newTrigger = htmlDoc.querySelector(".infinite-scroll-trigger");
            if (newTrigger && newTrigger.getAttribute("data-next-url")) {
              trigger.setAttribute("data-next-url", newTrigger.getAttribute("data-next-url"));
            } else {
              trigger.remove();
              wrapPagi?.remove();
              observer.disconnect();
            }

            if (typeof events === "function") events();
            isLoading = false;
          }).catch(() => {
            isLoading = false;
          });
        });
      },
      { threshold: 1.0 }
    );

    observer.observe(trigger);
  }

  document.addEventListener("DOMContentLoaded", initInfinite);
  document.addEventListener("shopify:section:load", initInfinite);
})();
